<div class="selectiveImportContent">
    <div class="heading">Update Project Items</div>
    <div class="loading-container" *ngIf="isLoadingSelectiveData">
        <div class="loading-spinner">
            <i class="fas fa-spinner fa-spin"></i>
            <span>Loading project data...</span>
        </div>
    </div>
    <div *ngIf="!isLoadingSelectiveData" class="container">
        <ul *ngFor="let epicList of selectiveEpic">
            <li>
                <input type="checkbox" [checked]="epicList.selected"
                    (change)="onEpicCheckboxChange($event, epicList)" />
                {{epicList._type}}: {{epicList.epic_name}}

                <div class="warning-message animate-fade">
                    {{ epicList.warningMessage }}
                </div>

                <div id="chiledListCss">
                    <ul>
                        <li *ngFor="let child of epicList.children">
                            <input type="checkbox" [checked]="child.selected"
                                (change)="onChildCheckboxChange($event, child)" />
                            {{child.issue_summary}}
                        </li>
                    </ul>
                </div>
            </li>
        </ul>

        <ul *ngFor="let featureList of selectiveFeature">
            <li><input type="checkbox"
                    (change)="onFeatureCheckboxChange($event, featureList)">{{featureList.issue_type}}:
                {{featureList.issue_summary}}
                <div id="chiledListCss">
                    <ul>
                        <li *ngFor="let child of featureList.children"><input type="checkbox">{{child.issue_summary}}
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
        <ul *ngFor="let scenarioList of selectiveScenario">
            <li><input type="checkbox"
                    (change)="onScenarioCheckboxChange($event, scenarioList)">{{scenarioList.issue_type}}:
                {{scenarioList.issue_summary}}
                <div id="chiledListCss">
                    <ul>
                        <li *ngFor="let child of scenarioList.children"><input type="checkbox">{{child.issue_summary}}
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>

    <div class="action-buttons">
        <button class="mab__button mab__button--primary" (click)="selectiveImport()">Import</button>
        <button class="mab__button mab__button--secondary" (click)="onCancel()">Cancel</button>
    </div>
</div>